<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12 mb-3">
                <h1 class="text-uppercase sb-main-header">CHANGE COVERAGE FORM</h1>
            </div>
        </div>

        <div class="card brd-primary">
            <div class="row justify-content-center">
                <div class="col-md-12 pt-3">
                    <p class="font-weight-bold pl-3 mb-4 sb-block-title">{{this.formName}} Request</p>
                </div>
            </div>
            <div class="row justify-content-center pl-4 pr-4 pb-2">
                <div class="col-md-12" >
                    <form  id="form">

                        <div class="row">
                            <div class=" col-sm-4 mt-4 " v-for="(qwst, index) in questions" v-if="canBeShown(qwst)">

                                <input type="hidden" name="form_id" :value="qwst.form_id" v-if="!index">

                                <div class="form-group" v-if="showTextInput(qwst)">
                                    <label :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</label>
                                    <input type="text" class="form-control" :name="'qwst_'+qwst.id"  :readonly="isReadOnly(qwst.readonly)"  :required="isRequired(qwst.required)" v-model="qwst.value">
                                </div>

                                <div class="form-group" v-if="showTextMaskInput(qwst)" >
                                    <label :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</label>
                                    <input type="text"  v-mask="'##/##/####'" class="form-control" :name="'qwst_'+qwst.id"    :required="isRequired(qwst.required)"  v-model="qwst.value" placeholder="mm/dd/yyyy">
                                </div>

                                <div class="form-group" v-if="showSingleSelect(qwst)">
                                    <label :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</label>
                                    <select  class="form-control" :name="'qwst_'+qwst.id"   :required="isRequired(qwst.required)"  v-model="qwst.value">
                                        <option value="">Please Select</option>
                                        plans
                                        <option v-for="t in qwst.choices.split('|')" :value="t">{{t}}</option>
                                    </select>
                                </div>

                                <p  v-if="showCheckboxInput(qwst)"  :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</p>
                                <div class="form-check" v-if="showCheckboxInput(qwst)" v-for="ch in getSource(qwst)">
                                    <input class="form-check-input" type="checkbox" :name="getName(qwst)"   :value="ch"  :required="isRequired(qwst.required)"  @click='deRequire(qwst)'  v-model="qwst.value">
                                    <label class="form-check-label">{{getLabel(qwst, ch, qwst.question)}}</label>
                                </div>

                                <div class="form-group" v-if="showNumberInput(qwst)">
                                    <label :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</label>
                                    <input type="number"  class="form-control" :name="'qwst_'+qwst.id"   :required="isRequired(qwst.required)" v-model="qwst.value">
                                </div>

                                <div class="form-group" v-if="showTextareaInput(qwst)">
                                    <label :class="getRequiredLabelClass(qwst.required)">{{ qwst.question }}</label>
                                    <textarea class="form-control" :name="'qwst_'+qwst.id"  :readonly="isReadOnly(qwst.readonly)"  :required="isRequired(qwst.required)" v-model="qwst.value">{{getDefaultValue(qwst)}}</textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12">
                                <button type="button" class="btn btn-primary float-right sbmt-btn" @click="submitForm" :disabled='isDisabled'>Submit Request</button>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script>


export default {
    props:['formName','user', 'plans'],

    mounted() {
        this.getQuestions();
    },
    data(){
        return {
            route: '/api/form/response',
            //u:this.user,
            questions:[],
            myInputModel: '',
            ch_source:[],
            isDisabled:false
        }
    },
    computed:{
    },
    methods:{
        canBeShown(question){

            if(question.parent_id && question.parent_value){
                if(_.find(this.questions, {id:question.parent_id}).value==question.parent_value)
                    return true;
                else
                    return false;
            }else{
                return true;
            }

        },
        getSource(qwst){
            if(qwst.source){
                var tname = qwst.source;
                return this[tname];
            }
            else{
                return qwst.choices.split('|');
            }

        },
        showTextMaskInput(qwst){

            if(qwst.type_name=="Single Textbox" && qwst.mask){
                return true;
            }
            else{
                return false;
            }
        },

        getDefaultValue(qwst){
            if(qwst.source){
                var tname = qwst.source;
                var arr = tname.split('.');
                return this[arr[0]][arr[1]]; //this.{$tname};
            }
        },

        deRequire(qwst_){

            //var el=document.getElementsByName(qwst);
            var qwst = this.getName(qwst_)
            var atLeastOneChecked=false;//at least one cb is checked
            $('[name="'+qwst+'"]').each(function () {
                if(this.checked){
                    atLeastOneChecked=true;
                    return false; // breaks
                }
            });

            if (atLeastOneChecked === true) {
                $('[name="'+qwst+'"]').each(function () {
                    $(this).prop('required', false);
                });
            } else {
                $('[name="'+qwst+'"]').each(function () {
                    $(this).prop('required', true);
                });
            }

        },

        getLabel(qwst, ch, question){

            var choices = this.getSource(qwst);
             if(Object.keys(choices).length>1 || qwst.source ){
                 return ch;
             }
             else{
                 return question;
             }
        },

        getName(qwst){
            var choices = this.getSource(qwst);
            if(Object.keys(choices).length>1){
                return 'qwst_'+qwst.id; //+'[]';
            }
            else{
                return 'qwst_'+qwst.id;
            }

        },

        getOptions(str){
            return str.join('|');
        },

        isRequired(required){

            //console.log(isRequired);

            if(required==1){
                return "required";

            }
            else{
                return false;
            }
        },

        getRequiredLabelClass(required){
            if(required==1){
                return 'col-form-label required';
            }
            else{
                return 'col-form-label';
            }
        },


        isReadOnly(readonly){
            if(readonly==1) {
                return true;
            }
            else{
                return false;
            }
        },
        showTextInput(qwst){
            if(qwst.type_name=="Single Textbox" && !qwst.mask){
                return true;
            }
            else{
                return false;
            }
        },
        showCheckboxInput(qwst){
            return qwst.type_name=="Checkbox Selection";
        },
        showSingleSelect(qwst){
            return qwst.type_name=="Single Selection";
        },
        showNumberInput(qwst){
            return qwst.type_name=="Number";
        },
        showTextareaInput(qwst){
            return qwst.type_name=="textarea";
        },


        getQuestions(){
            // window.location.href
            this.$http.get("/api/questions?form="+this.formName)
                .then(function(response) {
                    const questions = response.body;
                    questions.forEach((value, key)=>{
                        questions[key]['value']=this.getDefaultValue(value);
                        if(questions[key]['type_name']=='Checkbox Selection' && questions[key]['value']==undefined)
                            questions[key]['value']=[];
                    })
                    this.questions=questions;
                });
        },
        submitForm(){
            this.isDisabled = true;
            //$('sbmt-btn').prop('disa')
            let myForm = document.getElementById('form');
            //var valid =  myForm[0].checkValidity();
            var valid = $('#form')[0].checkValidity();

            if(!valid){
                //myForm.reportValidity();
                $('#form')[0].reportValidity();
                return false;
            }
            let formData = new FormData(myForm);

            var object = {};
            formData.forEach((value, key) => {
                // Reflect.has in favor of: object.hasOwnProperty(key)
                if(!Reflect.has(object, key)){
                    object[key] = value;
                    return;
                }
                if(!Array.isArray(object[key])){
                    object[key] = [object[key]];
                }
                object[key].push(value);
            });
            // var data = JSON.stringify(object);

            /*
            const data = {};
            // need to convert it before using not with XMLHttpRequest
            for (let [key, val] of formData.getAll()) {
                Object.assign(data, {[key]: val})
            }

            */

            //console.log(object);

            this.$http.post(this.route, object)
                .then(function(response) {

                    $('.has-error').removeClass('has-error')
                    $('.help-block').remove()
                    this.$notify({
                        type:'success',
                        title: 'Success',
                        text: response.bodyText
                    });
                    this.showModal=false;
                    //this.$router.push('/forms/confirmation/'+this.formName)
                    window.location.href = '/forms/confirmation/'+this.formName;

                }, (response) => {
                    this._handleErrors(response.data, '#form')
                    this.isDisabled = false;
                })
        },
        _handleErrors: function(items, selector)
        {
            $('.has-error').removeClass('has-error')
            $('.help-block').remove()

            for (var error in items['errors']) {
                if (items['errors'].hasOwnProperty(error)) {
                    var text = error;
                    var parts = text.split('.');
                    var name = parts.pop();
                    var el = $(selector + ' [name="'+name+'"]')
                    el.closest('.form-group').addClass('has-error')
                    $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                }
            }
        }
    }

}
</script>

